module.exports = __webpack_public_path__ + "static/media/Tax Diversification Brochure.d89c3d1c.pdf";